<div class="text-center">
  <output [ngClass]="'spinner-border ' + customCssClass">
    <span class="sr-only"></span>
  </output>
</div>
